import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="text-center flex flex-col items-center gap-4">
        <p className="text-8xl font-black text-accent">404</p>
        <h1 className="text-2xl font-bold text-fg">Страница не найдена</h1>
        <p className="text-sm max-w-xs text-muted">
          Кажется, эта страница потерялась где-то в другом измерении манги
        </p>
        <div className="flex gap-3 mt-2">
          <Link to="/" className="px-6 py-3 rounded-xl font-bold text-sm transition-all hover:opacity-90 bg-accent text-on-accent">
            На главную
          </Link>
          <Link to="/catalog" className="px-6 py-3 rounded-xl font-bold text-sm border border-line text-fg transition-all hover:border-accent">
            Каталог
          </Link>
        </div>
      </div>
    </div>
  )
}
